const HOVER_DIVIDER = '\n\n---\n\n';

/**
 * Build Monaco hover contents from LSP hover response.
 * Normalizes various hover content formats to Monaco markdown format.
 */
export function buildHoverContents(raw: any): { value: string; isTrusted?: boolean }[] {
  const segments = normalizeHoverContent(raw);
  if (!segments.length) {
    return [];
  }

  return [
    {
      value: segments.join(HOVER_DIVIDER),
      isTrusted: true
    }
  ];
}

/**
 * Normalize hover content to an array of markdown strings.
 */
function normalizeHoverContent(raw: any): string[] {
  if (!raw) {
    return [];
  }

  let segments: string[];

  if (Array.isArray(raw)) {
    segments = raw
      .map(normalizeHoverItem)
      .filter((segment): segment is string => Boolean(segment));
  } else {
    const single = normalizeHoverItem(raw);
    segments = single ? [single] : [];
  }

  return segments;
}

/**
 * Normalize a single hover item to markdown string.
 * Handles various LSP hover content formats.
 */
function normalizeHoverItem(item: any): string | null {
  if (!item) return null;

  // Plain string
  if (typeof item === 'string') {
    return item.trim() || null;
  }

  // MarkupContent with markdown
  if (item.kind === 'markdown' && item.value) {
    return typeof item.value === 'string' ? item.value : null;
  }

  // MarkedString with language (code block)
  if (item.language && item.value !== undefined) {
    return `\`\`\`${item.language}\n${item.value}\n\`\`\``;
  }

  // Object with value property
  if (item.value !== undefined) {
    const header = item.label ? `**${item.label}**\n` : '';
    return `${header}${item.value}`;
  }

  // Object with text property
  if (item.text) {
    return `${item.label ? `**${item.label}**\n` : ''}${item.text}`;
  }

  // Fallback: JSON dump
  try {
    return `\`\`\`json\n${JSON.stringify(item, null, 2)}\n\`\`\``;
  } catch {
    return null;
  }
}
